import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'orgbrain-radio-select-card',
  templateUrl: './radio-select-card.component.html',
  styleUrls: ['./radio-select-card.component.scss'],
  standalone: false,
})
export class RadioSelectCardComponent {
  @Input() disabled: boolean = false;
  @Input() class = '';
  @Input() label: string;
  @Input() icon: string;
  @Input() labelText: string;
  @Input() value: string | boolean | number;
  @Input() control: FormControl;
  @Output() selectOutput = new EventEmitter();

  select() {
    if (this.control) this.control.setValue(this.value);
    else if (this.selectOutput) this.selectOutput.emit(this.value);
  }
}
